export default "__VITE_ASSET__LQP$o87v__"